module.exports = __webpack_public_path__ + "img/home_actived.d55fdf12.svg";